export default "__VITE_ASSET__CZNHi$vu__"